import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import ReactWordcloud from '../react-wordcloud';
import words from '../words';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "basic-example"
    }}>{`Basic Example`}</h1>
    <p>{`Simply provide an array of words with valid `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`text`}</inlineCode>
      {` and `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`value`}</inlineCode>
      {` fields to begin!`}</p>
    <Playground mdxType="Playground">
      <ReactWordcloud words={words} mdxType="ReactWordcloud" />
    </Playground>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      